import { render, staticRenderFns } from "./EmpresaTipo.vue?vue&type=template&id=180b8da1&scoped=true"
import script from "./EmpresaTipo.vue?vue&type=script&lang=js"
export * from "./EmpresaTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b8da1",
  null
  
)

export default component.exports